/**
 * API errors already carry a human-readable message; anything else has no
 * message worth showing, so callers fall back to a translated string at render
 * time. Keeping `t` out of here is what lets data effects drop it from their
 * dependency list.
 */
export function toErrorMessage(error: unknown): string | null {
  return error instanceof Error ? error.message : null
}
